import { createIconComponent } from '../../factory/create-icon-component';
export const ArrowTopLeftIcon = createIconComponent(
  'ArrowTopLeftIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 20L4 4M4 4V15M4 4H15"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
